<template>
  <g :cy="`clock-num-${value}`"
     class="clock-num"
     :class="{ 'clock-num--selected': selected }"
     @click="$emit('select', value)">
    <circle :cx="x"
            :cy="y"
            :r="radius"
            class="clock-num__bg" />
    <text :x="x"
          :y="y"
          class="clock-num__text"
          text-anchor="middle"
          dominant-baseline="central">{{ display }}</text>
  </g>
</template>

<script>
export default {
  name: 'ClockNumber',
  props: {
    value: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    display: {
      type: [String, Number],
      default: ''
    },
    radius: {
      type: Number,
      default: 16
    }
  }
}
</script>

<style lang="less">
@import "../../styles/var";

.clock-num {
  cursor: pointer;

  &__bg {
    fill: transparent;
    transition: fill 0.15s ease;
  }

  &__text {
    font-size: 14px;
    fill: @dark-gray;
    user-select: none;
    pointer-events: none;
    transition: fill 0.15s ease;
  }

  &:hover &__bg {
    fill: rgba(41, 171, 226, 0.12);
  }

  &--selected &__bg {
    fill: @blue;
  }

  &--selected &__text {
    fill: white;
  }
}
</style>
